require('/ui/components/calloutbanner/calloutbanner.module.scss.module.css');

export const containerNeutral = "_container-neutral_kp6ma_1";
export const smallViewportSupport = "_small-viewport-support_kp6ma_1";
export const flush = "_flush_kp6ma_1";
export const containerWarning = "_container-warning_kp6ma_1";
export const containerError = "_container-error_kp6ma_1";
export const icon = "_icon_kp6ma_1";
export const content = "_content_kp6ma_1";
export const title = "_title_kp6ma_1";
